<template>
  <div class="tl-loading">
    Loading...
  </div>
</template>
<script>
export default {
  name: 'Loading'
}
</script>
<style lang="scss" scoped>
.tl-loading {
  font-size: 20px;
  height: 20px;
  width: 20px;
}
</style>
